import { render, staticRenderFns } from "./ModalOwner.vue?vue&type=template&id=11460b3e&scoped=true"
import script from "./ModalOwner.vue?vue&type=script&lang=js"
export * from "./ModalOwner.vue?vue&type=script&lang=js"
import style0 from "./ModalOwner.vue?vue&type=style&index=0&id=11460b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11460b3e",
  null
  
)

export default component.exports